import React from "react";
import { useFormContext } from "react-hook-form";

const InputTextarea = ({ ...props }) => {
  const { register } = useFormContext();

  return (
    <div>
      <label htmlFor={props.name} className="font-content text-embie-blue dark:text-embie-grey">
        {props.label}
      </label>
      <textarea
        rows={4}
        id={props.name}
        className="mt-2 py-2 px-2 shadow-sm focus:ring-1 focus:ring-embie-lightblue border border-embie-lightblue focus:outline-none block w-full sm:text-sm rounded-md"
        {...register(props.name, {})}
        {...props}
      />
    </div>
  );
};

export default InputTextarea;
